const localePattern = "(?:en|ja)"
const newsDetailPattern = new RegExp(`^/${localePattern}/news/([^/?#]+)/*$`)
const newsIndexPattern = new RegExp(`^/${localePattern}/news/*$`)
const careersDetailPattern = new RegExp(`^/${localePattern}/careers/([^/?#]+)/*$`)
const careersIndexPattern = new RegExp(`^/${localePattern}/careers/*$`)

export function newsTransitionName(slug: string) {
  return `news-${slug}`
}

export function careersTransitionName(slug: string) {
  return `careers-${slug}`
}

export function newsDetailSlug(pathname: string | undefined) {
  if (!pathname) return undefined
  return pathname.match(newsDetailPattern)?.[1]
}

export function careersDetailSlug(pathname: string | undefined) {
  if (!pathname) return undefined
  return pathname.match(careersDetailPattern)?.[1]
}

export function isNewsIndexPath(pathname: string | undefined) {
  return !!pathname && newsIndexPattern.test(pathname)
}

export function isCareersIndexPath(pathname: string | undefined) {
  return !!pathname && careersIndexPattern.test(pathname)
}

export function viewTransitionTypes(fromPathname: string | undefined, toPathname: string | undefined) {
  const toNewsSlug = newsDetailSlug(toPathname)
  if (toNewsSlug) return [newsTransitionName(toNewsSlug)]

  const fromNewsSlug = newsDetailSlug(fromPathname)
  if (fromNewsSlug && isNewsIndexPath(toPathname)) return [newsTransitionName(fromNewsSlug), "back"]

  const toCareersSlug = careersDetailSlug(toPathname)
  if (toCareersSlug) return [careersTransitionName(toCareersSlug)]

  const fromCareersSlug = careersDetailSlug(fromPathname)
  if (fromCareersSlug && isCareersIndexPath(toPathname))
    return [careersTransitionName(fromCareersSlug), "back"]

  return []
}

export function cssIdent(value: string) {
  return value.replace(/^-?\d|[^A-Za-z0-9_-]/g, (character, offset) => {
    const codePoint = character.codePointAt(0)?.toString(16) ?? "0"
    return offset === 0 && /[-\d]/.test(character) ? `\\${codePoint} ` : `\\${codePoint} `
  })
}
